import { useEffect, useState } from 'react';
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from "reactstrap";
import { useAppSelector, useAppDispatch } from 'app/hooks';
import { setOnBehalfOfOrganizationAdmin, clearOnBehalfOfOrganizationAdmin, OnBehalfOfOrganizationAdmin } from 'features/job-seeker-on-behalf-of-organization-admin';
import { getAdminInCommunitiesSelectList } from 'utils/job-seeker-on-behalf-of-organization-helper';
import './style.scss';

type Props = {
  title?: string;
  className?: string;
};

const OnBehalfOfOrganizationAdminSwitch = ({ title = "Admin view", className = '' }: Props) => {
  const dispatch = useAppDispatch();
  const jobSeeker = useAppSelector(state => state.jobSeekerAuth.jobSeeker);
  const onBehalfOfOrganizationAdmin = useAppSelector(state => state.jobSeekerOnBehalfOfOrganizationAdmin.onBehalfOfOrganizationAdmin);
  const [isAdminInCommunities, setIsAdminInCommunities] = useState<OnBehalfOfOrganizationAdmin[]>([]);

  const [dropdownIsOpen, setDropdownIsOpen] = useState<boolean>(false);
  const [currentMode, setCurrentTab] = useState<string>('AsMemeber');
  const toggleDropdown = () => {
    if (isAdminInCommunities.length > 1) {
      setDropdownIsOpen(!dropdownIsOpen);
    } else if (isAdminInCommunities.length === 1) {
      updateOnBehalfOfOrganizationAdmin(isAdminInCommunities[0]);
    }
  };

  useEffect(() => {
    const communitiesWithAdminRole = jobSeeker ? getAdminInCommunitiesSelectList(jobSeeker) : [];
    setIsAdminInCommunities(communitiesWithAdminRole);
  }, [jobSeeker]);

  useEffect(() => {
    if (jobSeeker && onBehalfOfOrganizationAdmin) {
      setCurrentTab('AsAdmin')
    } else {
      setCurrentTab('AsMemeber')
    }

  }, [dispatch, jobSeeker, onBehalfOfOrganizationAdmin]);

  const updateOnBehalfOfOrganizationAdmin = async (organization: OnBehalfOfOrganizationAdmin) => {
    dispatch(setOnBehalfOfOrganizationAdmin(organization));
  };

  const removeOnBehalfOfOrganizationAdmin = () => {
    dispatch(clearOnBehalfOfOrganizationAdmin());
  };

  return (
    <>
      <div className={`mode-switcher on-behalf-of-organization-admin-switcher ${onBehalfOfOrganizationAdmin?.text ? 'admin-mode-selected' : ''}`.trim()} >
        <span className="mode-switchers">
          <button type="button" className={`btn btn-secondary mode-switcher-btn ${!currentMode || currentMode === 'AsMemeber' ? 'active' : ''}`.trim()} key={currentMode || 'AsMemeber'} onClick={() => {
            removeOnBehalfOfOrganizationAdmin()
          }}>
            Member view
          </button>
          <Dropdown isOpen={dropdownIsOpen} toggle={toggleDropdown} className={`on-behalf-of-organization-admin-switcher-dropdown ${className}`}>
            <DropdownToggle className={`toggle-on-behalf-of-organization-admin-switcher mode-switcher-btn ${currentMode && currentMode === 'AsAdmin' ? 'active' : ''}`} key={currentMode}>
              {title}
            </DropdownToggle>
            <DropdownMenu>
              {isAdminInCommunities.map((organization: OnBehalfOfOrganizationAdmin) => {
                return <DropdownItem
                  key={organization.value}
                  className="menu-item"
                  onClick={() => { updateOnBehalfOfOrganizationAdmin(organization) }}
                >
                  {organization.text}
                </DropdownItem>
              })}
            </DropdownMenu>
          </Dropdown>
        </span>
      </div>
    </>
  );
}

export default OnBehalfOfOrganizationAdminSwitch;
